import { HttpErrorResponse } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { NotificationType } from 'angular2-notifications'
import { NotificationService } from '../notification.service'
import * as errorKeys from './error-keys.json'

@Injectable({
   providedIn: 'root',
})
export class AppErrorHandlerService {
   constructor(private _notificationService: NotificationService) {}

   handleError(errorResponse: HttpErrorResponse) {
      const isConnectionFailed = errorResponse.status === 0
      const isClientError = errorResponse.status >= 400 && errorResponse.status < 500
      let type = isConnectionFailed || isClientError ? NotificationType.Warn : NotificationType.Error
      let errorKey: keyof typeof errorKeys | '' = ''

      isConnectionFailed ? (errorKey = 'error_key_network') : (errorKey = errorResponse.error?.detail as keyof typeof errorKeys)

      this._notificationService.notify(type, undefined, errorKeys[errorKey] ?? 'We couldn’t complete your request. Please try again.')
   }
}
